<template>
<v-main class="hidden-lg-and-up pa-3 pt-5" style="margin-bottom:100px">
      <v-container>
       <p class="text-center">Share your Tippings page</p>
        <div style="margin-left:0px;max-width:740px">
              <div>
              <div>
              <v-btn
            x-large
            color="#1773ea"
            :href="`https://facebook.com/sharer/sharer.php?u=https://tippings.me/${username}`"
            target="_blank"
            style="color:white"
             class="animate__animated animate__fadeInUp"
             block

          >
            <v-icon color="white" class="mr-2 px-2">mdi-facebook</v-icon>
           Share on Facebook
          </v-btn>
          </div>
          <div>
          <v-btn
            x-large
            color="green"
            :href="
              `https://wa.me/?text=I%20just%20created%20an%20account%20on%20Tippings.%20Check%20out%20my%20Tippings%20page!%20https://tippings.me/${username}`
            "
            target="_blank"
            block
            style="color:white"
            class='mt-3 animate__animated animate__fadeInUp animate__delay-1s'
          >
            <v-icon color="white" class="mr-2 px-2">mdi-whatsapp</v-icon>
          Share on WhatsApp</v-btn>
          </div>
          <div>
          <v-btn
            x-large
            color="#1da1f2"
            :href="
              `https://twitter.com/intent/tweet?text=I%20just%20created%20an%20account%20on%Tippings.%20Check%20out%20my%20Tippings%20page%20https://tippings.me/${username}`
            "
            target="_blank"
          
            style="color:white"
            class='mt-3 animate__animated animate__fadeInUp animate__delay-2s'
            block
          >
            <v-icon color="white" class="mr-2 px-4">mdi-twitter</v-icon>
            Share on Twitter
          </v-btn>
          </div>
          <div>
          <v-btn
            x-large
            color="#2663ac"
            :href="
              `https://www.linkedin.com/shareArticle?mini=true&title=I%20just%20created%20an%20account%20on%Tippings.%20Check%20out%20my%20Tippings%20page%20https://tippings.me/${username}`
            "
            target="_blank"
            style="color:white"
             class='mt-3 animate__animated animate__fadeInUp animate__delay-3s'
            block
          >
            <v-icon color="white" class="mr-2 px-2">mdi-linkedin</v-icon>
         Share on LinkedIn </v-btn>
         </div>
              </div>
              </div> 
      </v-container>
    </v-main>
</template>



<script>


export default{
    props:{
        username:{
            type:String
        }
    }
}


</script>